// extracted by mini-css-extract-plugin
export default {"thoughts":"testimonial_thoughts__c0VNB","errorText":"testimonial_errorText__unvYS"};